import React from 'react'
import PropTypes from 'prop-types'
import { formatDate } from '../../../../../common/utils'
import classNames from 'classnames'

const ModifiedDate = ({ date, className, short, ignoreHours }) => {
  return (
    <span
      className={classNames('block', className)}
      data-testid="modified-date"
    >
      {formatDate(
        new Date(ignoreHours ? date.split('T')[0] : date).toUTCString(),
        {
          month: short ? 'short' : 'long',
        }
      )}
    </span>
  )
}

ModifiedDate.propTypes = {
  date: PropTypes.string.isRequired,
  short: PropTypes.bool,
  ignoreHours: PropTypes.bool,
  classNames: PropTypes.string,
}

ModifiedDate.defaultProps = {
  short: false,
  ignoreHours: false,
  className: 'text-base',
}

export default ModifiedDate
